import CabChassisActiveIcon from '@stack/assets/icons/body-type-icon/active/cab_chassis_active.svg';
import ConvertibleActiveIcon from '@stack/assets/icons/body-type-icon/active/convertible_active.svg';
import CoupeActiveIcon from '@stack/assets/icons/body-type-icon/active/coupe_active.svg';
import GranCoupeActiveIcon from '@stack/assets/icons/body-type-icon/active/gran_coupe_active.svg';
import HatchbackActionIcon from '@stack/assets/icons/body-type-icon/active/hatchback_active.svg';
import LorryActiveIcon from '@stack/assets/icons/body-type-icon/active/lorry_active.svg';
import MPVActiveIcon from '@stack/assets/icons/body-type-icon/active/mpv_active.svg';
import PickupTruckActiveIcon from '@stack/assets/icons/body-type-icon/active/pickup_truck_active.svg';
import RoadsterActiveIcon from '@stack/assets/icons/body-type-icon/active/roadster_active.svg';
import SedanActiveIcon from '@stack/assets/icons/body-type-icon/active/sedan_active.svg';
import SUVActiveIcon from '@stack/assets/icons/body-type-icon/active/suv_active.svg';
import VanActiveIcon from '@stack/assets/icons/body-type-icon/active/van_active.svg';
import WagonActiveIcon from '@stack/assets/icons/body-type-icon/active/wagon_active.svg';
import CabChassisDefaultIcon from '@stack/assets/icons/body-type-icon/default/cab_chassis_default.svg';
import ConvertibleDefaultIcon from '@stack/assets/icons/body-type-icon/default/convertible_default.svg';
import CoupeDefaultIcon from '@stack/assets/icons/body-type-icon/default/coupe_default.svg';
import GranCoupeDefaultIcon from '@stack/assets/icons/body-type-icon/default/gran_coupe_default.svg';
import HatchbackDefaultIcon from '@stack/assets/icons/body-type-icon/default/hatchback_default.svg';
import LorryDefaultIcon from '@stack/assets/icons/body-type-icon/default/lorry_default.svg';
import MPVDefaultIcon from '@stack/assets/icons/body-type-icon/default/mpv_default.svg';
import PickupTruckDefaultIcon from '@stack/assets/icons/body-type-icon/default/pickup_truck_default.svg';
import RoadsterDefaultIcon from '@stack/assets/icons/body-type-icon/default/roadster_default.svg';
import SedanDefaultIcon from '@stack/assets/icons/body-type-icon/default/sedan_default.svg';
import SUVDefaultIcon from '@stack/assets/icons/body-type-icon/default/suv_default.svg';
import VanDefaultIcon from '@stack/assets/icons/body-type-icon/default/van_default.svg';
import WagonDefaultIcon from '@stack/assets/icons/body-type-icon/default/wagon_default.svg';

export const carFilter = [
  {
    label: 'Cab Chassis',
    value: 'cab-chassis',
    svg: {
      default: <CabChassisDefaultIcon />,
      active: <CabChassisActiveIcon />,
    },
  },
  {
    label: 'Convertible',
    value: 'convertible',
    svg: {
      default: <ConvertibleDefaultIcon />,
      active: <ConvertibleActiveIcon />,
    },
  },
  {
    label: 'Coupe',
    value: 'coupe',
    svg: { default: <CoupeDefaultIcon />, active: <CoupeActiveIcon /> },
  },
  {
    label: 'Gran Coupe',
    value: 'gran-coupe',
    svg: { default: <GranCoupeDefaultIcon />, active: <GranCoupeActiveIcon /> },
  },
  {
    label: 'Hatchback',
    value: 'hatchback',
    svg: {
      default: <HatchbackDefaultIcon />,
      active: <HatchbackActionIcon />,
    },
  },
  {
    label: 'Lorry',
    value: 'lorry',
    svg: { default: <LorryDefaultIcon />, active: <LorryActiveIcon /> },
  },
  {
    label: 'MPV',
    value: 'mpv',
    svg: { default: <MPVDefaultIcon />, active: <MPVActiveIcon /> },
  },
  {
    label: 'Pickup Truck',
    value: 'pickup-truck',
    svg: {
      default: <PickupTruckDefaultIcon />,
      active: <PickupTruckActiveIcon />,
    },
  },
  {
    label: 'Roadster',
    value: 'roadster',
    svg: { default: <RoadsterDefaultIcon />, active: <RoadsterActiveIcon /> },
  },
  {
    label: 'Sedan',
    value: 'sedan',
    svg: { default: <SedanDefaultIcon />, active: <SedanActiveIcon /> },
  },
  {
    label: 'SUV',
    value: 'suv',
    svg: { default: <SUVDefaultIcon />, active: <SUVActiveIcon /> },
  },
  {
    label: 'Van',
    value: 'van',
    svg: { default: <VanDefaultIcon />, active: <VanActiveIcon /> },
  },
  {
    label: 'Wagon',
    value: 'wagon',
    svg: { default: <WagonDefaultIcon />, active: <WagonActiveIcon /> },
  },
];
